import { SelectItem } from "primeng/api/selectitem";
import { SortMeta } from "primeng/api/sortmeta";


export class TableTnFilters {
    tn = '';
    spid = '';
    spName = '';
    altSpid = '';
    laltSpid = '';
    ocn = '';
    ocnName = '';
    lata = '';
    rc = '';
    lrn = '';
    statuses: string[] = [];
    svTypes: string[] = [];
    regions: string[] = [];
    states: string[] = [];

    reset() {
        this.tn = '';
        this.spid = '';
        this.spName = '';
        this.altSpid = '';
        this.laltSpid = '';
        this.ocn = '';
        this.ocnName = '';
        this.lata = '';
        this.rc = '';
        this.lrn = '';
        this.statuses = [];
        this.svTypes = [];
        this.regions = [];
        this.states = [];
    }
}


export class TableTn {

    // table definition
    data: any[] = [];
    allCols: any[]; // main table columns + columns @ expandable area
    cols: any[];    // main table columns

    // filters
    showFilters = false;
    filters = new TableTnFilters();
    regions: SelectItem[];
    statuses: SelectItem[];
    svTypes: SelectItem[];
    states: SelectItem[];

    // sort
    sortOrder: SortMeta;

    // row index
    rows = 100; // p-table rows - page size
    first = 0;  // p-table first - the index of the first row on the current page

    // for single row in TN table,  do expansion automatically
    // [expandedRowKeys]="dataTableTn.expandedRows"
    expandedRows = {};
    expandedRowKeys = {};

    constructor() {

        this.allCols = [
            // main table columns
            { field: 'tn', header: 'TN' },
            { field: 'status', header: 'Status', 
                toolTip: '1. Native:The TN is not ported 2. Ported Pool: The TN is not ported and part of a pool block 3. Ported Inter: TN port event from one service provider to another 4. Ported Intra:TN port event within the service provider. 5. Snapback Inter:Disconnect event after an inter-port. TN returned to the block/code owner. 6. Snapback Intra:Disconnect event after an intra-port. TN returned to the block/code owner. 7. Snapback: Disconnect event where the LNP Type was not provided. TN returned to the block/code owner'
            },
            { field: 'aTime', header: 'Event Date/Time (ET)' },
            { field: 'lrn', header: 'LRN' },
            { field: 'svType', header: 'SV Type' },
            { field: 'spid', header: 'SPID' },
            { field: 'spName', header: 'SP Name' },
            { field: 'altSpid', header: 'Alt SPID' },
            { field: 'laltSpid', header: 'Last Alt SPID' },
            { field: 'ocn', header: 'OCN' },
            { field: 'ocnName', header: 'OCN Name' },
            { field: 'region', header: 'Region' },
            { field: 'state', header: 'State' },
            { field: 'lata', header: 'LATA' },
            { field: 'lataName', header: 'LATA Name' },
            { field: 'rc', header: 'Rate Center' },
            

            { field: 'switch', header: 'LRN Switch' },
          
            // Routing Data
            { field: 'clssDpc', header: 'Class DPC' },
            { field: 'clssSsn', header: 'Class SSN' },
            { field: 'lidbDpc', header: 'LIDB DPC' },
            { field: 'lidbSsn', header: 'LIDB SSN' },
            { field: 'isvmDpc', header: 'ISVM DPC' },
            { field: 'isvmSsn', header: 'ISVM SSN' },
            { field: 'cnamDpc', header: 'CNAM DPC' },
            { field: 'cnamSsn', header: 'CNAM SSN' },
            { field: 'wsmsDpc', header: 'WSMSC DPC' },
            { field: 'wsmsSsn', header: 'WSMSC SSN' },

            // More Porting Data
            { field: 'eulv', header: 'End User Location Value' },
            { field: 'eult', header: 'End User Location Type' },
            { field: 'billingId', header: 'Billing ID' },
            { field: 'altEulv', header: 'Alt End User Location Value' },
            { field: 'altEult', header: 'Alt End User Location Type' },
            { field: 'altBid', header: 'Alt Billing ID' },
            { field: 'svId', header: 'SV ID' },

            // IP Fields
            { field: 'voiceUri', header: 'Voice URI' },
            { field: 'mmsUri', header: 'MMS URI' },
            { field: 'smsUri', header: 'SMS URI' },
        ];

        this.cols = [
            { field: 'tn', header: 'TN', width: '10.1' },
            { field: 'status', header: 'Status', width: '11',
            toolTip: '1. Native: The TN is not ported or pooled \n 2. Ported-pool: TN is part of a Number Pool Block \n 3. Ported-inter: TN ported from one service provider to another \n 4. Ported-intra: TN ported within the service provider \n 5. Snapback: TN returned to the block or code owner' },
            { field: 'aTime', header: 'Event Date/Time (ET)', width: '12.5', toolTip:'Date/time when the TN was ported or snapbacked' },
            { field: 'lrn', header: 'LRN', width: '9.6', toolTip: 'LRN for a ported TN or for a Number Pool Block' },
            { field: 'svType', header: 'SV Type', width: '8' },
            { field: 'spid', header: 'SPID', width: '6.7', toolTip:'NPAC SPID for a ported TN or for the block or code owner' },
            { field: 'spName', header: 'SP Name', width: '13' },
            { field: 'altSpid', header: 'Alt SPID', width: '6.2' },
            { field: 'laltSpid', header: 'Last Alt SPID', width: '6.4' },
            { field: 'ocn', header: 'OCN', width: '6.5', toolTip:'OCN for the block or code owner from LERG6' },
            { field: 'ocnName', header: 'OCN Name', width: '13'},
            { field: 'region', header: 'Region', width: '8' },
            { field: 'state', header: 'State', width: '7'},
            { field: 'lata', header: 'LATA', width: '7' },
            { field: 'rc', header: 'Rate Center', width: '11.5' }
            
        ];

        // populate SelectItem API for Regions
        this.regions = [
            { label: 'n/a', value: '' },
            { label: 'Mid-Atlantic', value: 'Mid-Atlantic' },
            { label: 'Midwest', value: 'Midwest' },
            { label: 'Northeast', value: 'Northeast' },
            { label: 'Southeast', value: 'Southeast' },
            { label: 'Southwest', value: 'Southwest' },
            { label: 'West Coast', value: 'West Coast' },
            { label: 'Western', value: 'Western' }
        ];

        // populate SelectItem API for Status
        this.statuses = [
            { label: 'n/a', value: '' },
            { label: 'Native', value: 'Native' },
            { label: 'Ported-inter', value: 'Ported-inter' },
            { label: 'Ported-intra', value: 'Ported-intra' },
            { label: 'Ported-pool', value: 'Ported-pool' }
        ];

        // populate SelectItem API for SV Type
        this.svTypes = [
            { label: 'class1And2VoIP-WithNumAssgnmt', value: 'class1And2VoIP-WithNumAssgnmt' },
            { label: 'class2VoIP-noNumAssgnmt', value: 'class2VoIP-noNumAssgnmt' },
            { label: 'prepaid-wireless', value: 'prepaid-wireless' },
            { label: 'sv-type-6', value: 'sv-type-6' },
            { label: 'sv-type-7', value: 'sv-type-7' },
            { label: 'sv-type-8', value: 'sv-type-8' },
            { label: 'sv-type-9', value: 'sv-type-9' },
            { label: 'voWiFi', value: 'voWiFi' },
            { label: 'wireless', value: 'wireless' },
            { label: 'wireline', value: 'wireline' },
        ];
        
        this.states = [
            {label: 'AL', value: 'AL'},
            {label: 'AK', value: 'AK'},
            {label: 'AZ', value: 'AZ'},
            {label: 'AR', value: 'AR'},
            {label: 'CA', value: 'CA'},
            {label: 'CO', value: 'CO'},
            {label: 'CT', value: 'CT'},
            {label: 'DE', value: 'DE'},
            {label: 'DC', value: 'DC'},
            {label: 'FL', value: 'FL'},
            {label: 'GA', value: 'GA'},
            {label: 'HI', value: 'HI'},
            {label: 'ID', value: 'ID'},
            {label: 'IL', value: 'IL'},
            {label: 'IN', value: 'IN'},
            {label: 'IA', value: 'IA'},
            {label: 'KS', value: 'KS'},
            {label: 'KY', value: 'KY'},
            {label: 'LA', value: 'LA'},
            {label: 'ME', value: 'ME'},
            {label: 'MD', value: 'MD'},
            {label: 'MA', value: 'MA'},
            {label: 'MI', value: 'MI'},
            {label: 'MN', value: 'MN'},
            {label: 'MS', value: 'MS'},
            {label: 'MO', value: 'MO'},
            {label: 'MT', value: 'MT'},
            {label: 'NE', value: 'NE'},
            {label: 'NV', value: 'NV'},
            {label: 'NH', value: 'NV'},
            {label: 'NJ', value: 'NJ'},
            {label: 'NM', value: 'NM'},
            {label: 'NY', value: 'NY'},
            {label: 'NC', value: 'NC'},
            {label: 'ND', value: 'ND'},
            {label: 'OH', value: 'OH'},
            {label: 'OK', value: 'OK'},
            {label: 'OR', value: 'OR'},
            {label: 'PA', value: 'PA'},
            {label: 'PR', value: 'PR'},
            {label: 'RI', value: 'RI'},
            {label: 'SC', value: 'SC'},
            {label: 'SD', value: 'SD'},
            {label: 'TN', value: 'TN'},
            {label: 'TX', value: 'TX'},
            {label: 'UT', value: 'UT'},
            {label: 'VT', value: 'VT'},
            {label: 'VA', value: 'VA'},
            {label: 'WA', value: 'WA'},
            {label: 'WV', value: 'WV'},
            {label: 'WI', value: 'WI'},
            {label: 'WY', value: 'WY'},

        ];

        // set default sort order
        this.sortOrder = { field: '', order: 1 };
    }

}

